export function isInteger(str: string): boolean {
  return parseInt(str).toString() === str;
}
